import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-website-layout',
  templateUrl: './website-layout.component.html',
  styleUrls: ['./website-layout.component.scss']
})
export class WebsiteLayoutComponent implements OnInit {
detalleCompra() {
throw new Error('Method not implemented.');
}

  menuVariable:boolean=false
  menu_icon_variable:boolean=false

  cart = 0;
  url = environment.imgUrl;
  constructor( 
    // private webService:WebService,
   ) {
    // this.cart = this.webService.getCardProduct().length;
    }

  ngOnInit(): void {
    console.log(this.cart);
     
  }

  openMenu(){
    this.menuVariable =! this.menuVariable;
    // this.menu_icon_variable =! this.menu_icon_variable;
    
  }

}
